import React from 'react';
import { ArrowDown, Phone, Mail } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo, heroImage } from '../data/mock';

const Hero = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="inicio"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="Construction site with cranes"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/95 via-slate-900/80 to-slate-900/60" />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900/90 via-transparent to-slate-900/30" />
      </div>

      {/* Diagonal Accent */}
      <div className="absolute bottom-0 left-0 right-0 h-32 overflow-hidden">
        <div
          className="absolute -bottom-16 left-0 right-0 h-32 bg-amber-500 transform -skew-y-2"
          style={{ clipPath: 'polygon(0 60%, 100% 0%, 100% 100%, 0% 100%)' }}
        />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
        <div className="max-w-3xl">
          {/* Company Name */}
          <div className="mb-8 animate-in fade-in slide-in-from-left duration-700">
            <h1 className="text-6xl sm:text-7xl lg:text-8xl font-bold text-white tracking-tight mb-2">
              {companyInfo.name.replace('+', '')}
              <span className="text-amber-500">+</span>
            </h1>
            <p className="text-xl sm:text-2xl text-slate-400 tracking-[0.3em] uppercase">
              {companyInfo.subtitle}
            </p>
          </div>

          {/* Tagline */}
          <div className="mb-10 animate-in fade-in slide-in-from-left duration-700 delay-150">
            <p className="text-2xl sm:text-3xl lg:text-4xl text-white font-light leading-tight">
              <span className="text-amber-500">Construindo</span> o presente.
              <br />
              <span className="text-slate-300">Transformando</span> o futuro.
            </p>
          </div>

          {/* Description */}
          <p className="text-lg text-slate-400 mb-10 max-w-xl animate-in fade-in slide-in-from-left duration-700 delay-300">
            {companyInfo.description}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 animate-in fade-in slide-in-from-left duration-700 delay-500">
            <Button
              onClick={() => scrollToSection('#contato')}
              className="bg-amber-500 hover:bg-amber-600 text-slate-900 font-bold text-lg px-8 py-6 transition-all duration-200 hover:scale-105 hover:shadow-lg hover:shadow-amber-500/25"
            >
              <Phone className="w-5 h-5 mr-2" />
              Solicitar Orçamento
            </Button>
            <Button
              variant="outline"
              onClick={() => scrollToSection('#projetos')}
              className="border-2 border-slate-400 text-slate-300 hover:bg-slate-800 hover:border-amber-500 hover:text-amber-500 font-semibold text-lg px-8 py-6 transition-all duration-200"
            >
              Ver Projetos
            </Button>
          </div>

          {/* Quick Contact */}
          <div className="mt-12 flex flex-col sm:flex-row gap-6 text-slate-400 animate-in fade-in slide-in-from-left duration-700 delay-700">
            <a
              href={`mailto:${companyInfo.email}`}
              className="flex items-center gap-2 hover:text-amber-500 transition-colors"
            >
              <Mail className="w-5 h-5" />
              <span>{companyInfo.email}</span>
            </a>
            <a
              href={`tel:${companyInfo.phone.replace(/[^0-9]/g, '')}`}
              className="flex items-center gap-2 hover:text-amber-500 transition-colors"
            >
              <Phone className="w-5 h-5" />
              <span>{companyInfo.phone}</span>
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-24 left-1/2 transform -translate-x-1/2 animate-bounce z-10">
        <button
          onClick={() => scrollToSection('#sobre')}
          className="text-white/60 hover:text-amber-500 transition-colors"
        >
          <ArrowDown className="w-8 h-8" />
        </button>
      </div>
    </section>
  );
};

export default Hero;
